const { MinimogThemeStyles, MinimogThemeScripts } = window;

class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal();
    this.isOpen = false;
    this.isLoading = false;

    // Event delegation for quick view button
    addEventDelegate({
      selector: ".m-product-quickview-button",
      handler: (e, target) => {
        e.preventDefault();

        if (this.isLoading) return;

        this.target = target;
        this.toggleLoading(true);

        const productHandle = target.dataset.productHandle;

        /*
          pcard-swatch يحدّث أول input باسم id داخل Product Card
          عند اختيار العميل للفارينت/الوزن.
        */
        const productCard = target.closest(".m-product-card");
        const selectedVariantId = productCard?.querySelector('[name="id"]')?.value;

        if (productHandle) {
          this.loadProductQuickView(productHandle, selectedVariantId);
        }
      },
    });

    // Subscribe to cart update events
    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) this.modal.close();
    });

    window.MinimogEvents.subscribe("ON_MODAL_CLOSED", (modal) => {
      this.close();
    });
  }

  // Load product quick view HTML
  loadProductQuickView(productHandle, variantId = "") {
    if (this.isOpen) {
      this.modal && this.modal.close();
    }

    this.isLoading = true;

    /*
      إضافة رقم الفارينت المختار إلى رابط المنتج.
      إذا لم يختَر العميل وزنًا، يفتح الثيم بالفارينت الافتراضي.
    */
    const variantQuery = variantId
      ? `?variant=${encodeURIComponent(variantId)}`
      : "";

    fetchSection("product-quickview", {
      url: `${window.MinimogSettings.base_url}products/${productHandle}${variantQuery}`,
    })
      .then((html) => {
        this.modalContent = html.querySelector(
          "#MainProduct-quick-view__content"
        );

        const productInfo = html.querySelector("product-info");
        const colorScheme = productInfo.dataset.colorScheme;

        this.modal.appendChild(this.modalContent);
        this.modal.setWidth("960px");

        const sectionWrapper = this.modal.modal.querySelector(
          "#MainProduct-quick-view__content"
        );

        sectionWrapper.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");

          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });

          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          );

          oldScriptTag.parentNode.replaceChild(
            newScriptTag,
            oldScriptTag
          );
        });

        this.modal.open();
        this.modal.setSizes(`m-gradient ${colorScheme}`);

        this.toggleLoading(false);
        this.isOpen = true;
        this.isLoading = false;
      })
      .then(() => {
        document.dispatchEvent(
          new CustomEvent("tcustomizer-custom-show-quick-view", {
            detail: {
              productHandle: this.target.dataset.productHandle,
            },
          })
        );

        document.dispatchEvent(
          new CustomEvent("quick-view:loaded", {
            detail: {
              productUrl: this.target.dataset.productHandle,
            },
          })
        );
      })
      .catch((error) => {
        console.error("Error loading product quick view:", error);

        this.toggleLoading(false);
        this.isLoading = false;
      });
  }

  // Close the quick view modal
  close() {
    this.isOpen = false;
  }

  // Toggle loading spinner on the target element
  toggleLoading(isLoading) {
    if (!this.target) return;

    if (isLoading) {
      this.target.classList.add("m-spinner-loading");
    } else {
      this.target.classList.remove("m-spinner-loading");
    }
  }
}

// Initialize the QuickView instance
MinimogTheme.ProductQuickView = new QuickView();